import { Text, Anchor, Heading } from "grommet";

export function LoginText() {
  return (
    <Text>
      This website provides the <strong>FactorECG</strong> tool, accompanying the paper: "A novel method for explainable deep neural
      network-based interpretation of 12-lead electrocardiograms using variational auto-encoders"
    </Text>
  );
}

export function Citation() {
  return (
    <Text>
      The paper about the FactorECG can be found{" "}
      <Anchor href="https://www.medrxiv.org/content/10.1101/2022.01.04.22268759v1" label="here" />.
    </Text>
  );
}

export function SidebarHeading() {
  return (
    <Heading level={1} textAlign="start" margin="none">
      Generate 12-lead ECG data using a VAE decoder
    </Heading>
  );
}

export function MajorDescription() {
  return (
    <Text>
      This tool provides an interactive way to visualize an inherently explainable deep neural network (DNN), that learned the underlying
      anatomical and (patho)physiological explanatory factors of variation of the ECG: <b>the FactorECG</b>.
    </Text>
  );
}

export function MinorDescription() {
  return (
    <Text>
      The ECG can be compressed into 21 significant factors, that allow for reconstruction of the full median beat ECG. To encode the ECG
      into these factors, an unsupervised beta variational auto-encoder (VAE) was trained to reconstruct 1,144,331 median beat ECGs from
      these 21 factors. The current trained model is able to encode any median beat ECG into these 21 factors, and is able to interactively
      generate new ECGs by adjusting the factors.
      <br />
      <br />
      The obtained ECG factors can be used to perform explainable diagnosis or prediction using common statistical methods. In the paper, we
      show that only using the 21 interpretable factors, we are able to reach performances similar to a state-of-the-art ‘black box’ DNN in
      standard ECG interpretation, and novel ECG use cases, such as diagnosis of reduced ejection fraction and prediction of one-year
      mortality.
    </Text>
  );
}

export function Instructions() {
  return (
    <Text>
      The goal of this tool is to make the 21 significant ECG factors interpretable for any clinician. The factors can be varied
      interactively using the sliders at the top of the window, while the ECG is generated real-time. Moreover, several example ECGs are
      included on the right to investigate the state of the ECG factors for these examples. Finally, interpretations of the ECG factors are
      provided when hovering over the dimension sliders.
    </Text>
  );
}
